import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';

export default function ThankYouPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to right, #fceabb, #f8b500)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <Typography variant="h3" fontWeight={700} gutterBottom>
          Thank You!
        </Typography>
        <Typography variant="h6" color="text.secondary" mb={4}>
          Your message has been sent successfully. We’ll get back to you soon.
        </Typography>

        <Button
          component={Link}
          to="/"
          variant="contained"
          size="large"
          sx={{ mt: 2 }}
        >
          Return Home
        </Button>
      </Container>
    </Box>
  );
}
